export const NOTIFICATION_POPUP_DEBOUNCE_MS = 300;
export const NOTIFICATION_BADGE_MAX = 99;

/** Notification popup dialog sizing — closer to the Lovable demo panel. */
export const NOTIFICATION_POPUP_MAX_HEIGHT_CLS =
  "h-[min(85vh,900px)] max-h-[min(85vh,900px)]";
export const NOTIFICATION_POPUP_WIDTH_CLS =
  "w-[min(1180px,96vw)] max-w-[1180px]";

export const NOTIFICATION_META_CLS =
  "text-sm font-normal leading-snug tabular-nums text-muted-foreground";

/** Mosaic motion — gated by motion-safe / hover media in components. */
export const NOTIFICATION_TILE_MOTION_CLS =
  "transition-[transform,box-shadow] duration-200 ease-out motion-safe:active:scale-[0.98] [@media(hover:hover)_and_(pointer:fine)]:motion-safe:hover:-translate-y-0.5";

/** Shared chrome fill — solid muted + input border so controls read on bg-background. */
export const SURFACE_CONTROL_CLS =
  "border border-input bg-muted text-foreground/80 shadow-sm";

/** Shared chrome controls for the notification popup. */
export const SURFACE_ICON_BTN_CLS =
  `size-9 shrink-0 rounded-full ${SURFACE_CONTROL_CLS} transition-[transform,background-color,color,border-color] duration-150 ease-out hover:border-input-enhanced hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:scale-[0.97] motion-reduce:active:scale-100`;

export const SURFACE_BACK_BTN_CLS =
  `inline-flex h-9 items-center gap-1.5 rounded-full ${SURFACE_CONTROL_CLS} px-3.5 text-sm font-medium transition-[transform,background-color,color,border-color] duration-150 ease-out hover:border-input-enhanced hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:scale-[0.98] motion-reduce:active:scale-100`;

export const SURFACE_SEARCH_CLS =
  `flex h-9 w-full rounded-full ${SURFACE_CONTROL_CLS} pl-9 pr-9 text-sm outline-none placeholder:text-sm placeholder:text-muted-foreground focus-visible:border-ring focus-visible:text-foreground focus-visible:ring-1 focus-visible:ring-ring`;
